import { Component, OnInit } from '@angular/core';
import { Vestiging } from '../models/vestiging.model';

@Component({
  selector: 'app-branch',
  templateUrl: './branch.component.html',
  styleUrls: ['./branch.component.sass']
})
export class BranchComponent implements OnInit {

  vestiging:Vestiging = new Vestiging();

  constructor() {
    this.vestiging.naam = "Wellen";
    this.vestiging.straat = "Bosstraat";
    this.vestiging.huisnummer = 24;
    this.vestiging.toevoeging = "B";
    this.vestiging.gemeente = "Wellen";
  }

  ngOnInit(): void {
  }

}
